import React, { useState } from "react";
import {
	Typography,
	FormControl,
	FormLabel,
	RadioGroup,
	FormControlLabel,
	Radio,
	Divider,
	Avatar,
	Checkbox,
	Collapse,
	IconButton,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";

import {
	radioDefaultIcon,
	radioCheckedIcon,
	checkBoxCheckedIcon,
	checkboxDefaultIcon,
} from "utility/icons";
import { Shared } from "utility/shared";
import { collapseUpDefaultIcon, collapseDownDefaultIcon } from "assets/images";

export class AwardAmtGridDetail {
	item: string = "";
	qty: number = 0;
	estUnitCost: number = 0;
	isChecked: boolean = false;
}

export class ItemSelectionGridDetail {
	bidId: number = 0;
	bidNumber: string = "";
	awardAmount: number = 0;
	convertedAmount: number = 0;
	remainingAmount: number = 0;
	isChecked: boolean = false;
	items: AwardAmtGridDetail[] = [];
}

const itemList: ItemSelectionGridDetail[] = [
	{
		bidId: 1,
		bidNumber: "BID005",
		awardAmount: 1200000,
		remainingAmount: 1200000,
		convertedAmount: 0,
		isChecked: false,
		items: [
			{
				isChecked: false,
				item: "GP Support Service",
				qty: 10,
				estUnitCost: 40000,
			},
			{
				isChecked: false,
				item: "GP Upgrade",
				qty: 10,
				estUnitCost: 50000,
			},
			{
				isChecked: false,
				item: "SQL Upgrade",
				qty: 10,
				estUnitCost: 20000,
			},
			{
				isChecked: false,
				item: "Creditors Recon",
				qty: 10,
				estUnitCost: 10000,
			},
		],
	},
	{
		bidId: 2,
		bidNumber: "BID005",
		awardAmount: 1200000,
		remainingAmount: 1200000,
		convertedAmount: 0,
		isChecked: false,
		items: [
			{
				isChecked: false,
				item: "Blockchain Technology",
				qty: 10,
				estUnitCost: 26000,
			},
		],
	},
	{
		bidId: 3,
		bidNumber: "BID005",
		awardAmount: 1200000,
		remainingAmount: 1200000,
		convertedAmount: 0,
		isChecked: false,
		items: [
			{
				isChecked: false,
				item: "Caseware Support Service",
				qty: 10,
				estUnitCost: 44000,
			},
		],
	},
];

export const ContractItemSelection: React.FC = () => {
	const [estimationLogicTypeId, setEstimationLogicTypeId] = useState<
		number | null
	>(null);
	const [panelList, setPanelList] = useState<string[]>([]);

	const handleEstimationLogicTypeChange = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		setEstimationLogicTypeId(Number(event.target.value));
	};

	const handlePanelOpenClose = (id: string) => {
		if (panelList.includes(id)) {
			setPanelList(panelList.filter((p) => p !== id));
		} else {
			setPanelList(panelList.concat(id));
		}
	};

	return (
		<div className="item-selection-panel">
			<div
				style={{ paddingRight: "19px !important" }}
				id="contract-item-selection-header"
				className="item-selection-header"
			>
				<Typography variant="h4">Awarder Bid Selection</Typography>
				{itemList.length > 0 ? (
					<div className="content">
						<FormControl className="radio-btn" sx={{ width: "45% !important" }}>
							<FormLabel id="demo-row-radio-buttons-group-label">
								Varying Price Logic
							</FormLabel>
							<RadioGroup
								row
								value={estimationLogicTypeId}
								onChange={handleEstimationLogicTypeChange}
							>
								<FormControlLabel
									value={1}
									control={
										<Radio
											icon={radioDefaultIcon}
											checkedIcon={radioCheckedIcon}
										/>
									}
									label="Average"
								/>
								<FormControlLabel
									value={2}
									control={
										<Radio
											icon={radioDefaultIcon}
											checkedIcon={radioCheckedIcon}
										/>
									}
									label="Split"
								/>
							</RadioGroup>
						</FormControl>
						<div className="text-label-wrapper" id="text-label-proc-method">
							<Typography variant="body1" className="light-grey-text">
								Proc Method
							</Typography>
							<Typography variant="h4" className="default-text">
								Open Tender
							</Typography>
						</div>
						<div className="text-label-wrapper">
							<Typography variant="body1" className="light-grey-text">
								Award Total
							</Typography>
							<Typography variant="h4" className="default-text">
								{Shared.getFormattedCurrency(8200000)}
							</Typography>
						</div>
					</div>
				) : (
					<>
						<Divider />
						<Typography
							className="content"
							variant="body1"
							justifyContent="center"
							pt={2}
						>
							No Data Available
						</Typography>
					</>
				)}
			</div>
			{itemList.map((item: ItemSelectionGridDetail, index: number) => (
				<TableContainer
					component={Paper}
					className="item-selection-table"
					key={index}
				>
					<div className="table-responsive">
						<Table className="item-collapsible-table">
							<TableHead>
								<TableRow>
									<TableCell></TableCell>
									<TableCell></TableCell>
									<TableCell></TableCell>
									<TableCell>Award Amt</TableCell>
									<TableCell>Converted Amt</TableCell>
									<TableCell>Remaining Amt</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								<TableRow className="collapsible-row h-45">
									<TableCell>
										<IconButton
											className="collapse-icon"
											size="small"
											onClick={() =>
												handlePanelOpenClose(`${item.bidId.toString()}`)
											}
										>
											{panelList.includes(`${item.bidId.toString()}`) ? (
												<Avatar src={collapseUpDefaultIcon} alt="Up Icon" />
											) : (
												<Avatar src={collapseDownDefaultIcon} alt="Down Icon" />
											)}
										</IconButton>
									</TableCell>
									<TableCell>
										<Checkbox
											className="custom-checkbox"
											checkedIcon={checkBoxCheckedIcon}
											icon={checkboxDefaultIcon}
											checked={item.isChecked}
										/>
									</TableCell>
									<TableCell className="req-id">{item.bidNumber}</TableCell>
									<TableCell>
										{Shared.getFormattedCurrency(item.awardAmount)}
									</TableCell>
									<TableCell>
										{Shared.getFormattedCurrency(item.convertedAmount)}
									</TableCell>
									<TableCell>
										{Shared.getFormattedCurrency(item.remainingAmount)}
									</TableCell>
								</TableRow>

								<TableRow className="method-detail-row">
									<TableCell style={{ padding: 0 }} colSpan={6}>
										<Collapse
											in={panelList.includes(item.bidId.toString())}
											timeout="auto"
											unmountOnExit
										>
											<Table className="fixed-table-layout">
												<TableHead>
													<TableRow className="h-35">
														<TableCell className="w-28"></TableCell>
														<TableCell className="w-60"></TableCell>
														<TableCell className="w-160">Item</TableCell>
														<TableCell className="w-60">Qty</TableCell>
														<TableCell align="center" className="w-110">
															Amount
														</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{item.items.map(
														(
															subItem: AwardAmtGridDetail,
															subItemIndex: number
														) => (
															<TableRow key={subItemIndex}>
																<TableCell></TableCell>
																<TableCell align="center">
																	<Checkbox
																		className="custom-checkbox"
																		checkedIcon={checkBoxCheckedIcon}
																		icon={checkboxDefaultIcon}
																		checked={subItem.isChecked}
																	/>
																</TableCell>
																<TableCell className="cell-content-space">
																	{subItem.item}
																</TableCell>
																<TableCell className="cell-content-space">
																	{subItem.qty}
																</TableCell>
																<TableCell
																	align="center"
																	className="cell-content-space"
																>
																	{Shared.getFormattedCurrency(
																		subItem.estUnitCost
																	)}
																</TableCell>
															</TableRow>
														)
													)}
												</TableBody>
											</Table>
										</Collapse>
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</div>
				</TableContainer>
			))}
			<style>
				{`
                    #contract-item-selection-header { padding-right: 19px !important }
                    #text-label-proc-method { margin-right: 10px !important }
                    #text-label-proc-method h4 { font-size: 16px; }
                `}
			</style>
		</div>
	);
};
